"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Toast = exports.Content = exports.IconStyled = exports.CloseButtonStyled = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _button = _interopRequireDefault(require("@paprika/button"));

var _includes = require("@paprika/stylers/lib/includes");

var types = _interopRequireWildcard(require("./types"));

var _backgroundColors, _borderColors, _closeButtonColors, _iconColors;

var backgroundColors = (_backgroundColors = {}, (0, _defineProperty2["default"])(_backgroundColors, types.toastKinds.SUCCESS, _tokens["default"].color.greenLighten50), (0, _defineProperty2["default"])(_backgroundColors, types.toastKinds.WARNING, _tokens["default"].color.yellowLighten30), (0, _defineProperty2["default"])(_backgroundColors, types.toastKinds.ERROR, _tokens["default"].color.orangeLighten40), (0, _defineProperty2["default"])(_backgroundColors, types.toastKinds.INFO, _tokens["default"].color.cremeLighten5), (0, _defineProperty2["default"])(_backgroundColors, types.toastKinds.LOCKED, _tokens["default"].color.yellowLighten30), _backgroundColors); // Calculated by brightness.

var borderColors = (_borderColors = {}, (0, _defineProperty2["default"])(_borderColors, types.toastKinds.SUCCESS, "#c5e2d3"), (0, _defineProperty2["default"])(_borderColors, types.toastKinds.WARNING, "#f2deaf"), (0, _defineProperty2["default"])(_borderColors, types.toastKinds.ERROR, "#f2c2b8"), (0, _defineProperty2["default"])(_borderColors, types.toastKinds.INFO, "#dbd8d0"), (0, _defineProperty2["default"])(_borderColors, types.toastKinds.LOCKED, "#f2deaf"), _borderColors);
var closeButtonColors = (_closeButtonColors = {}, (0, _defineProperty2["default"])(_closeButtonColors, types.toastKinds.SUCCESS, _tokens["default"].color.greenDarken20), (0, _defineProperty2["default"])(_closeButtonColors, types.toastKinds.WARNING, _tokens["default"].color.yellowDarken40), (0, _defineProperty2["default"])(_closeButtonColors, types.toastKinds.ERROR, _tokens["default"].color.orangeLighten40), (0, _defineProperty2["default"])(_closeButtonColors, types.toastKinds.LOCKED, _tokens["default"].color.yellowLighten30), _closeButtonColors);
var fixedStyles = (0, _styledComponents.css)(["left:50%;max-width:675px;position:fixed;top:", ";transform:translateX(-50%);width:calc(100% - ", ");"], _stylers["default"].spacer(2), _stylers["default"].spacer(4));
var iconColors = (_iconColors = {}, (0, _defineProperty2["default"])(_iconColors, types.toastKinds.SUCCESS, _tokens["default"].color.green), (0, _defineProperty2["default"])(_iconColors, types.toastKinds.WARNING, _tokens["default"].color.yellowDarken10), (0, _defineProperty2["default"])(_iconColors, types.toastKinds.ERROR, _tokens["default"].color.orange), (0, _defineProperty2["default"])(_iconColors, types.toastKinds.INFO, _tokens["default"].color.blue), (0, _defineProperty2["default"])(_iconColors, types.toastKinds.LOCKED, _tokens["default"].color.yellowDarken10), _iconColors);
var CloseButtonStyled = (0, _styledComponents["default"])(_button["default"].Close).withConfig({
  displayName: "Toaststyles__CloseButtonStyled",
  componentId: "sc-1e0oo3r-0"
})(function (_ref) {
  var kind = _ref.kind;
  return (0, _styledComponents.css)(["flex-grow:0;flex-shrink:0;margin-left:", ";min-height:0;", ""], _tokens["default"].space, closeButtonColors[kind] && "color: ".concat(closeButtonColors[kind], ";"));
});
exports.CloseButtonStyled = CloseButtonStyled;

var IconStyled = _styledComponents["default"].div.withConfig({
  displayName: "Toaststyles__IconStyled",
  componentId: "sc-1e0oo3r-1"
})(function (_ref2) {
  var kind = _ref2.kind;
  return (0, _styledComponents.css)(["color:", ";flex-grow:0;flex-shrink:0;margin:1px ", " 0 0;", ""], iconColors[kind], _tokens["default"].space, _stylers["default"].fontSize(2));
});

exports.IconStyled = IconStyled;

var Content = _styledComponents["default"].div.withConfig({
  displayName: "Toaststyles__Content",
  componentId: "sc-1e0oo3r-2"
})(["flex-grow:1;flex-shrink:1;"]);

exports.Content = Content;

var Toast = _styledComponents["default"].div.withConfig({
  displayName: "Toaststyles__Toast",
  componentId: "sc-1e0oo3r-3"
})(function (_ref3) {
  var isFixed = _ref3.isFixed,
      kind = _ref3.kind,
      zIndex = _ref3.zIndex,
      shouldRender = _ref3.shouldRender;
  return (0, _styledComponents.css)(["align-items:flex-start;background-color:", ";border-color:", ";border-radius:", ";border-style:solid;border-width:1px;color:", ";display:flex;font-weight:normal;margin-bottom:", ";min-height:", ";padding:", ";position:relative;text-align:left;transition:opacity 0.3s ease-out;word-break:break-word;z-index:", ";", "  ", "  ", " ", ";"], backgroundColors[kind], borderColors[kind], _tokens["default"].border.radius, _tokens["default"].color.black, _stylers["default"].spacer(2), _stylers["default"].spacer(3), _tokens["default"].spaceLg, zIndex, _stylers["default"].fontSize(), _stylers["default"].lineHeight(), isFixed ? fixedStyles : null, !shouldRender || kind === types.toastKinds.VISUALLY_HIDDEN ? _includes.visuallyHidden : null);
});

exports.Toast = Toast;
//# sourceMappingURL=Toast.styles.js.map